// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.6d2434c2',
  revision: '6d2434c2',
  branch: 'develop',
  date: 'Fri, 10 Apr 2026 10:08:18 GMT'
};